import { MusicTranscriptionController } from "./MusicTranscriptionController";
import MusicTranscriptionTimer from "./MusicTranscriptionTimer";

export const musicTranscriptionController = new MusicTranscriptionController();
export const musicTranscriptionTimer = new MusicTranscriptionTimer();